import React from "react";
import { Skeleton } from "antd";

export const SkeltonLoader = ({ number, active, className,style }) => {
  let loaders = [];
  for (let i = 0; i < number; i++) {
    loaders.push(
      <div className={className}>
        <Skeleton.Node style={style} active={active} className={"w-100"} />
      </div>
    );
  }

  return loaders.map((item) => item);
};
